const UploadPrescriptionConfig = [
    { span: 8, height: "30px", classes: "marginTop-32" },
    { span: 4, height: "20px", classes: "marginTop-8" },
    { span: 12, height: "220px", classes: "marginTop-24" },
]
export default UploadPrescriptionConfig
